import ZoneList from '../marketingManager/ZoneList'

const AdminZoneList = () => {
    return (
        <>
            <ZoneList />
        </>
    )
}

export default AdminZoneList